/**
 * @fileoverview Call to action select view. Handles opening the dialog and
 * setting/resetting model data.
 *
 * @author Gil Walzer (gwalzer@yext.com)
 */
goog.module('yext.social.post.CallToActionView');
goog.module.declareLegacyNamespace();
const CallToActionDialog = goog.require('yext.social.post.CallToActionDialog');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');

/** @constructor */
const CallToActionView = function() {
  this.$context = $('.js-post-call-to-action-container');
  this.$callToActionDialog = new CallToActionDialog(
    function(callToAction) {
      this.setModel_(callToAction);
      this.render_();
    }.bind(this),
  );
  this.$addCallToActionLink = this.$context.find('.js-add-call-to-action');
  this.$disabledCallToAction = this.$context.find('.js-disabled-call-to-action');
  this.$disabledCallToAction.contextualHelp({'location': 'right'});

  this.$editCallToActionLink = this.$context.find('.js-edit-call-to-action-link');
  this.$editCallToActionContainer = this.$context.find('.js-edit-call-to-action-container');
  this.$removeCallToActionLink = this.$context.find('.js-remove-call-to-action-link');

  /**
  * @type {!Object}
  * @private
  */
  this.model_ = {
    'callToActionModel': null,
    'disabled': false,
    'hidden': false,
  };

  this.init_();
};

/**
 * @param disabled {boolean}
 */
CallToActionView.prototype.disable = function(disabled) {
  this.model_['disabled'] = disabled;
  if (disabled) {
    this.model_['callToActionModel'] = null;
  }
  this.render_();
};

/** @param hidden {boolean} */
CallToActionView.prototype.hide = function(hidden) {
  this.model_['hidden'] = hidden;
  if (hidden) {
    this.model_['callToActionModel'] = null;
  }
  this.render_();
};

/**
 * @return {!Object}
 */
CallToActionView.prototype.getData = function() {
  return {
    'callToAction': this.model_['callToActionModel'],
  };
};

CallToActionView.prototype.reset = function() {
  this.setModel_(undefined);
  this.render_();
};

/** @param {!Object<string, ?>} callToAction */
CallToActionView.prototype.setCallToAction = function(callToAction) {
  if (callToAction['customField'] == null && callToAction['customUrl'] == null) {
    callToAction['customField'] = {
      'customFieldId': 0, // Featured Message
    };
  }
  this.model_['callToActionModel'] = callToAction['type'] != null
    ? {
      'callToActionTypeId': callToAction['type'],
      'urlField': callToAction['customUrl'] || function() {
        var customFieldId = callToAction['customField'] == null
          ? null
          : callToAction['customField']['customFieldId'];
        return customFieldId == null
          ? null
          : this.$callToActionDialog.getCustomFieldName(customFieldId);
      }.bind(this)(),
      'customFieldId': callToAction['customField'] == null
        ? null
        : callToAction['customField']['customFieldId'],
      'callToActionName': this.$callToActionDialog.getCallToActionTypeName(callToAction['type']),
    }
    : null;
  this.render_();
};

/**
 * @private
 */
CallToActionView.prototype.init_ = function() {
  this.bindAddLink_();
  this.bindEditLink_();
  this.bindRemoveLink_();
};

/**
 * @private
 */
CallToActionView.prototype.bindAddLink_ = function() {
  this.$addCallToActionLink.on('click', this.onAdd_.bind(this));
};

/**
 * @private
 */
CallToActionView.prototype.onAdd_ = function(event) {
  this.$callToActionDialog.openDialog();
};

/**
 * @private
 */
CallToActionView.prototype.bindEditLink_ = function() {
  this.$editCallToActionLink.on('click', this.onEdit_.bind(this));
};

/**
 * @private
 */
CallToActionView.prototype.onEdit_ = function(event) {
  if (this.model_['callToActionModel'] != null) {
    this.$callToActionDialog.openDialogFromModel(this.model_['callToActionModel']);
  } else {
    this.$callToActionDialog.openDialog();
  }
};

/**
 * @private
 */
CallToActionView.prototype.bindRemoveLink_ = function() {
  this.$removeCallToActionLink.on('click', this.onRemove_.bind(this));
  this.render_();
};

/**
 * @private
 */
CallToActionView.prototype.onRemove_ = function() {
  this.model_['callToActionModel'] = null;
  this.render_();
};

/**
 * @private
 * @param callToAction {!Object}
 */
CallToActionView.prototype.setModel_ = function(callToAction) {
  this.model_['callToActionModel'] = callToAction;
};

/** @private */
CallToActionView.prototype.render_ = function() {
  if (this.model_['hidden']) {
    this.$context.remove();
    return;
  }

  var model = this.model_['callToActionModel'];
  if (this.model_['disabled']) {
    this.$disabledCallToAction.show();
    this.$addCallToActionLink.hide();
    this.$editCallToActionContainer.hide();
  } else if (model == null) {
    this.$addCallToActionLink.show();
    this.$editCallToActionContainer.hide();
    this.$disabledCallToAction.hide();
  } else {
    this.$addCallToActionLink.hide();
    this.$editCallToActionContainer.show();
    this.$disabledCallToAction.hide();

    var callToActionName = model['callToActionName'];
    var urlField = model['urlField'];
    if (urlField) {
      this.$editCallToActionContainer.find('.js-call-to-action-url').text(urlField);
    }
    this.$editCallToActionContainer.find('.js-call-to-action-name').text(callToActionName);
  }
};


exports = CallToActionView;
